// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"a2dff5ed","967":"c82a9451"}[chunkId] + ".chunk.js";
};